import { axios } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'

const altRiderLists = (data) => ({
  type: TYPES.ALT_RIDER_LISTS,
  data,
})

export const getAllRiders = (page = 1, limit = 10, search = '') => async (dispatch) => {
  try {
    const queryParams = new URLSearchParams({ page, limit, search }).toString()
    const response = await axios.get(`/rider?${queryParams}`)
    
    if (response && response.data) {
      const normalizedData = {
        data: response.data.map(rider => ({
          id: rider.id,
          firstName: rider.firstName,
          lastName: rider.lastName,
          fullName: `${rider.firstName} ${rider.lastName}`,
          email: rider.email,
          phone: rider.phone,
          vehicleType: rider.vehicleType,
          vehicleNumber: rider.vehicleNumber,
          licenseNumber: rider.licenseNumber,
          status: rider.assignmentStatus || rider.status,
          assignmentId: rider.assignmentId,
          createdAt: rider.createdAt,
          updatedAt: rider.updatedAt,
        })),
        pagination: response.pagination,
      }
      
      dispatch(altRiderLists(normalizedData))
    }
  } catch (error) {
    console.error('Get riders error:', error)
    toast.error(error.response?.data?.message || 'Failed to fetch riders')
  }
}

export const checkRiderEmail = async (email) => {
  try {
    const response = await axios.get(`/rider/check-email/${encodeURIComponent(email)}`)
    return response.exists
  } catch (error) {
    console.error('Check email error:', error)
    return false
  }
}

export const createRider = (riderData) => async (dispatch) => {
  try {
    const response = await axios.post('/rider', riderData)
    
    if (response && response.status === 'success') {
      toast.success('Rider added successfully')
      dispatch(getAllRiders())
      return { success: true }
    }
  } catch (error) {
    console.error('Create rider error:', error)
    const message = error.response?.data?.message || 'Failed to add rider'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const updateRider = (id, riderData) => async (dispatch) => {
  try {
    const response = await axios.put(`/rider/${id}`, riderData)
    
    if (response && response.status === 'success') {
      toast.success('Rider updated successfully')
      dispatch(getAllRiders())
      return { success: true }
    }
  } catch (error) {
    console.error('Update rider error:', error)
    const message = error.response?.data?.message || 'Failed to update rider'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const toggleRiderStatus = (id) => async (dispatch) => {
  try {
    const response = await axios.patch(`/rider/${id}/status`)
    
    if (response && response.status === 'success') {
      toast.success('Rider status updated successfully')
      dispatch(getAllRiders())
    }
  } catch (error) {
    console.error('Toggle status error:', error)
    toast.error(error.response?.data?.message || 'Failed to update rider status')
  }
}

export const deleteRider = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(`/rider/${id}`)
    
    if (response && response.status === 'success') {
      toast.success('Rider removed from your company successfully')
      dispatch(getAllRiders())
      return { success: true }
    }
  } catch (error) {
    console.error('Delete rider error:', error)
    toast.error(error.response?.data?.message || 'Failed to remove rider')
    return { success: false }
  }
}

export const assignExistingRider = (email) => async (dispatch) => {
  try {
    const response = await axios.post('/rider/assign-existing', { email })
    
    if (response && response.status === 'success') {
      toast.success('Rider assigned to your company successfully')
      dispatch(getAllRiders())
      return { success: true }
    }
  } catch (error) {
    console.error('Assign existing rider error:', error)
    const message = error.response?.data?.message || 'Failed to assign rider. Please check the email and try again.'
    toast.error(message)
    return { success: false, message }
  }
}

export const verifyRiderEmail = async (email) => {
  try {
    const response = await axios.post('/rider/verify-email', { email })
    
    if (response && response.status === 'success') {
      return { 
        success: true, 
        rider: response.data 
      }
    }
    return { success: false, message: 'Rider not found' }
  } catch (error) {
    console.error('Verify rider email error:', error)
    const message = error.response?.data?.message || 'Rider not found. Please check the email address.'
    return { success: false, message }
  }
}
